/**
 * Shared Utilities - Moon Moon Agency
 * Essential utilities and helpers shared across all modules
 */

/*********************************************************************************************
 * 🌐 GLOBAL SETTINGS
 */
// Development mode detection (self-contained)
window.isDev = ['localhost', '127.0.0.1'].includes(location.hostname)
	|| location.hostname.startsWith('192.168.')
	|| location.hostname.startsWith('10.0.')
	|| location.hostname.endsWith('.myshopify.com');

// Breakpoints (synced with CSS — desktop-first)
window.WIDE_BREAKPOINT = 1440;
window.MEDIUM_DESKTOP_BREAKPOINT = 1280;
window.SMALL_DESKTOP_BREAKPOINT = 1024;
window.TABLET_BREAKPOINT = 990;
window.MOBILE_BREAKPOINT = 768;

/*********************************************************************************************
 * 🛠️ SHARED UTILITIES
 */
// Simple logging utility
window.log = (level, module, message, data = {}) => {
	if (!window.isDev && level === 'info') return;
	if (typeof console !== 'undefined') {
		const logFn = console[level] || console.log;
		const timestamp = window.getTimestamp?.() || new Date().toLocaleString();
		logFn(`${module} ${message}`, { timestamp, ...data });
	}
};

// Simple event emitter
window.emit = (event, detail = {}) => {
	return document.dispatchEvent(new CustomEvent(event, {
		detail: { timestamp: window.getTimestamp?.() || new Date().toLocaleString(), ...detail },
		bubbles: true
	}));
};

// DOM utilities
window.getElement = (selector) => document.querySelector(selector);
window.getElements = (selector) => document.querySelectorAll(selector);

// Device detection (use these instead of hardcoded breakpoints in modules)
window.isMobile = () => window.innerWidth <= window.MOBILE_BREAKPOINT;
window.isTablet = () => window.innerWidth <= window.TABLET_BREAKPOINT;
window.isSmallDesktop = () => window.innerWidth <= window.SMALL_DESKTOP_BREAKPOINT;
window.isMediumDesktop = () => window.innerWidth <= window.MEDIUM_DESKTOP_BREAKPOINT;
window.isWide = () => window.innerWidth > window.WIDE_BREAKPOINT;
window.isDesktop = () => window.innerWidth > window.TABLET_BREAKPOINT;
window.debounce = (fn, delay) => {
	let timeout;
	return (...args) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn(...args), delay);
	};
};

/*********************************************************************************************
 * 🕐 TIMESTAMP UTILITIES
 */
// French timestamp formatter
window.getTimestamp = () => new Date().toLocaleString('fr-FR', {
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit'
});

/*********************************************************************************************
 * 🎯 ACCESSIBILITY - Share URL Select on Click (replace inline onclick)
 */
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-share-url]').forEach((input) => {
		input.addEventListener('click', () => {
			input.select();
		});
	});
});

/*********************************************************************************************
 * 🔧 DEVELOPMENT LOGGING
 */
if (window.isDev) {
	const eventConfig = {
		// Navigation & Menu events
		'mobile-menu-toggled': '📱',
		'mobile-menu-closed': '📱',
		'mobile-submenu-next': '📱',
		'mobile-submenu-prev': '📱',
		'background-filter-activated': '🌫️',
		'background-filter-deactivated': '🌫️',
		'mega-menu-products-switched': '🗂️',

		// Search events
		'search-opened': '🔍',
		'search-closed': '🔍',

		// UI Components events
		'dropdown-toggled': '📖',
		'read-more-toggled': '📝',
		'document-height-updated': '📐',
		'splide-initialized': '🎠',
		'loader-activated': '⏳',

		// Media events
		'video-manager-initialized': '🎥',

		// Recommendations events
		'product-recommendations-loaded': '🛍️',
		'product-recommendations-loading': '🛍️',
	};

	Object.entries(eventConfig).forEach(([event, emoji]) => {
		document.addEventListener(`global:${event}`, e =>
			console.log(`${emoji} [${event.toUpperCase()}]:`, e.detail)
		);
	});

	// Cart events (cart: prefix)
	const cartEvents = ['opened', 'closed', 'quantity-increased', 'quantity-decreased', 'free-product-adding', 'count-updated', 'add-to-cart-start', 'add-to-cart-success', 'add-to-cart-error'];
	cartEvents.forEach(event => {
		document.addEventListener(`cart:${event}`, e =>
			console.log(`🛒 [CART ${event.toUpperCase()}]:`, e.detail)
		);
	});
}